<script setup lang="ts">
const { t } = useI18n({ useScope: "local" });
const props = defineProps<{ id: string }>();

const { field } = useInlineBlockEditor(props.id);

const columnsSettings = field<Record<string, number>>("columnsSettings", { default: 1 });

const sliderModel = computed({
  get: () => [columnsSettings.value?.default ?? 1],
  set: (value: number[]) => {
    columnsSettings.value = {
      ...(columnsSettings.value ?? {}),
      default: value[0] ?? 1,
    };
  },
});
</script>

<template>
  <EditorSection :title="t('title')" icon="lucide:box-select" accent="container">
    <EditorField :label="t('columnsLabel')" :hint="t('columnsHint')">
      <div class="flex items-center gap-3">
        <Slider v-model="sliderModel" :min="1" :max="12" :step="1" class="flex-1" />
        <span class="w-8 text-right font-mono text-[12.5px] text-muted-foreground">
          {{ columnsSettings?.default ?? 1 }}
        </span>
      </div>
    </EditorField>
  </EditorSection>
</template>

<i18n lang="yaml">
en:
  title: "Container"
  columnsLabel: "Columns"
  columnsHint: "Set the default number of grid columns."
</i18n>
